'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelTransaction = exports.getBingoTransactions = exports.getFantasyTransactions = exports.getSportsbookTransactions = exports.getGamePlayTransactions = exports.getPayments = exports.getTransaction = exports.getTransactions = undefined;

var _transaction = require('tg-core-api/lib/transaction');

var _transaction2 = _interopRequireDefault(_transaction);

var _action = require('../../lib/action');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTransactions = exports.getTransactions = function getTransactions(playerSessionID, max, offset, transactionType) {
  return (0, _action.makeApiCallAction)('GET_TRANSACTIONS', _transaction2.default.getTransactions(playerSessionID, max, offset, transactionType));
};
var getTransaction = exports.getTransaction = function getTransaction(playerSessionID, transactionID) {
  return (0, _action.makeApiCallAction)('GET_TRANSACTION', _transaction2.default.getTransaction(playerSessionID, transactionID));
};

var getPayments = exports.getPayments = function getPayments(playerSessionID, max, offset, type) {
  return (0, _action.makeApiCallAction)('GET_PAYMENT_TRANSACTIONS', _transaction2.default.getPayments(playerSessionID, max, offset, type));
};

var getGamePlayTransactions = exports.getGamePlayTransactions = function getGamePlayTransactions(playerSessionID, max, offset) {
  return (0, _action.makeApiCallAction)('GET_GAMEPLAY_TRANSACTIONS', _transaction2.default.getGamePlayTransactions(playerSessionID, max, offset));
};

var getSportsbookTransactions = exports.getSportsbookTransactions = function getSportsbookTransactions(playerSessionID, max, offset) {
  return (0, _action.makeApiCallAction)('GET_SPORTSBOOK_TRANSACTIONS', _transaction2.default.getSportsbookTransactions(playerSessionID, max, offset));
};

var getFantasyTransactions = exports.getFantasyTransactions = function getFantasyTransactions(playerSessionID, max, offset) {
  return (0, _action.makeApiCallAction)('GET_FANTASY_TRANSACTIONS', _transaction2.default.getFantasyTransactions(playerSessionID, max, offset));
};

var getBingoTransactions = exports.getBingoTransactions = function getBingoTransactions(playerSessionID, max, offset) {
  return (0, _action.makeApiCallAction)('GET_BINGO_TRANSACTIONS', _transaction2.default.getBingoTransactions(playerSessionID, max, offset));
};

var cancelTransaction = exports.cancelTransaction = function cancelTransaction(playerSessionID, transactionID) {
  return (0, _action.makeApiCallAction)('CANCEL_TRANSACTION', _transaction2.default.cancelTransaction(playerSessionID, transactionID));
};

exports.default = {
  getTransactions: getTransactions,
  getTransaction: getTransaction,
  getPayments: getPayments,
  getGamePlayTransactions: getGamePlayTransactions,
  getSportsbookTransactions: getSportsbookTransactions,
  getFantasyTransactions: getFantasyTransactions,
  getBingoTransactions: getBingoTransactions,
  cancelTransaction: cancelTransaction
};